import { render, staticRenderFns } from "./FiBuNewBuchungsstapel.vue?vue&type=template&id=c88c9c36&"
import script from "./FiBuNewBuchungsstapel.vue?vue&type=script&lang=js&"
export * from "./FiBuNewBuchungsstapel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports